import convertToTime from "../../../../app/utils/time/convertToTime";
export const configureTimeWindow = (record) => {
  if (!record?.hasTimeWindow) return null;
  if (!record?.timeWindowEnd)
    return `${convertToTime(record?.timeWindowStart)}`;
  return `${convertToTime(record?.timeWindowStart)} - ${convertToTime(
    record?.timeWindowEnd
  )}`;
};
